// extracted by mini-css-extract-plugin
export default {"sideImg":"style_sideImg__C8pM-","mobAds":"style_mobAds__R3ATN","storeImg":"style_storeImg__tNQ0z","moblieImg":"style_moblieImg__ktNzb"};